import React, { useEffect, useState } from "react";
const AboutUs = () => {
  const [data,setData]=useState([]);
  useEffect(() => {
    fetch("https://kvrstarlightmedicalacademy.com/api/founders.php")
      .then((response) => response.json())
      .then((data) => setData(data));
      console.log(data);
  },[]);
  return (
    <div>
      { data && data.map((element) => {
        return (
          <div key={element.id}>
            <div>
              <h2 className="about_h2">{element.heading} </h2>
            </div>
            <div className="about_row">
              <p className="about_para ">{element.para}</p>
              <img
                src={element.imageurl}
                className="img-fluid about_image"
                alt="First"
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AboutUs;
